/**
 * API handling utilities for AI Prescription
 */

import React from 'react';
import { parseAIPrescriptionText, AIPrescriptionPayload } from '../../Apis/AIPrescriptionApis';
import { ConversationItem } from './types';

interface HandlePrescriptionAPIOptions {
  logContext: string;
  structuredData: any[];
  lastConversation: ConversationItem;
  onMedicationData?: (response: any, medicationDataArray: any[], repromptMessage: string) => {
    prescriptions: any[];
    aiResponse: string;
    originalPrescription?: any;
    structuredMedicationData?: any[];
    showPharmacyList?: boolean;
  } | null;
  onSuccess?: (response: any, updatedStructuredData: any[], repromptMessage: string) => {
    prescriptions: any[];
    aiResponse: string;
    originalPrescription?: any;
  };
  onError?: () => {
    prescriptions: any[];
    aiResponse: string;
    originalPrescription?: any;
  };
}

/**
 * Reusable function to handle parseAIPrescriptionText API calls
 */
export const handlePrescriptionAPI = (
  payload: AIPrescriptionPayload,
  conversationId: number,
  options: HandlePrescriptionAPIOptions,
  callbacks: {
    updatePharmacy: (data: any) => void;
    updateConversation: (id: number, updates: Partial<ConversationItem> | ((conv: ConversationItem) => ConversationItem)) => void;
    setIsSearching: (value: boolean) => void;
    isMounted: () => boolean;
    resultMessageProcessedRef: React.MutableRefObject<boolean>;
  }
) => {
  parseAIPrescriptionText(payload)
    .then((_response: any) => {
      // DON'T process medication_data or set aiResponse here
      // Pharmacy is updated only via WebSocket (useWebSocketMessageHandler handleResultMessage)
      // Wait for WebSocket type=result callback to handle it
      // This ensures AIPrescriptionFetchingProcess is shown until type=result arrives
      // Keep isLoading: true and aiResponse: "" until WebSocket callback processes type=result
      // Do NOT set aiResponse or isLoading here - let WebSocket callback handle it
      return;
    })
    .catch((error) => {
      if (!callbacks.isMounted()) return;
      console.error(`API call error for ${options.logContext}:`, error);
      // Keep isLoading: true to show AIPrescriptionFetchingProcess
      // Don't set aiResponse here, wait for WebSocket
      // If WebSocket fails, the error will be handled by the WebSocket callback
    });
};

